import * as React from 'react'

import { Button, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  onClickExport: () => void
}

const PopoverMenu = ({ onClickExport }: Props) => {
  const [open, toggle] = useToggle(false)

  return (
    <Tooltip.Alt
      attachment="top center"
      open={open}
      toggle={toggle}
      label={i18n.t('calendar.export.title')}
    >
      <Button onClick={onClickExport} type="secondary" iconName="calendar" />
    </Tooltip.Alt>
  )
}

export { PopoverMenu }
